import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchGroupsSelect, fetchGroupsByExtension } from 'modules/groups/actions';
import { getAllGroupsSelect, getGroupsByExtension, getGroupsIsFetching } from 'modules/groups/selectors';

const DEFAULT_PARAMETERS = {
  sort: 'name,asc',
  reducer: ['id,none', 'name,none'],
};

/**
 * @typedef {{
 *  extension?: import('modules/global/typing/enums/extensions.enum').ExtensionEnum
 * }} useGroupsProps
 */

/** @type {React.FC<useGroupsProps>} */
const useGroups = (params) => {
  const dispatch = useDispatch();

  const { extension } = params ?? {};

  const groups = useSelector(getAllGroupsSelect);
  const isFetching = useSelector(getGroupsIsFetching);
  const groupsByExtension = useSelector(state => getGroupsByExtension(state, extension));

  React.useEffect(() => {
    if (extension) {
      dispatch(fetchGroupsByExtension(extension));
    } else {
      dispatch(fetchGroupsSelect({ ...DEFAULT_PARAMETERS, ...params }));
    }
  }, [dispatch, extension, params]);

  return {
    groups: extension ? groupsByExtension : groups,
    isFetching,
  };
};

export default useGroups;
